import { TipoTag } from "interfaces/typesystem";
import api from "./api";

export async function saveTipoTag(payload: {
  tipo: string;
  qtd_atleta_necessario?: number;
  cor?: string;
}): Promise<TipoTag> {
  const { data, status } = await api.post("/tipo-tags", payload);

  if (status === 201) {
    return data;
  }

  throw new Error(data?.message || "Erro ao criar tag");
}

export async function listTipoTags(): Promise<TipoTag[]> {
  const { data, status } = await api.get("/tipo-tags");

  if (status === 200 && Array.isArray(data)) {
    return data;
  }

  throw new Error(data?.message || "Erro ao listar tags");
}

export async function deleteTipoTag(id: number): Promise<TipoTag> {
  const { data, status } = await api.delete(`/tipo-tags/${id}`);

  if (status === 200) {
    return data;
  }

  throw new Error(data?.message || "Erro ao excluir tag");
}
